import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const WebhookPixPagamentoList = (props) => <DefaultDataTable data={props} />
